import breakpoints from '../data/breakpoints';
import Slider from '../components/slider';

class Testimonials {
    constructor(el) {
        this.el = el;
        this.imageEl = el.find('.testimonials__image');
        this.sliderEl = el.find('.slider');
        this.slider = new Slider(this.sliderEl, {
            dots: false,
            arrows: true,
            fade: true,
            responsive: [
                {
                    breakpoint: breakpoints.desktop - 1,
                    settings: {
                        variableWidth: false
                    }
                }
            ]
        });
        this.sliderEl.on('beforeChange', this.beforeChange.bind(this));
    }
    beforeChange(e, slick, currentSlideIndex, nextSlideIndex) {
        const nextSlide = this.slider.getSlide(nextSlideIndex).find('.testimonials__slide');
        const newImage = nextSlide.data('image');
        let fadeImageEl = this.imageEl.clone();
        fadeImageEl.insertAfter(this.imageEl);
        this.imageEl.css('background-image', `url(${newImage}`);
        fadeImageEl.fadeOut(200, () => { fadeImageEl.remove(); });
        let currentCaption = this.getSlideCaption(currentSlideIndex);
        let nextCaption = this.getSlideCaption(nextSlideIndex);
        currentCaption.fadeOut(200, () => {
            currentCaption.removeClass('active');
            nextCaption.addClass('active');
        });
    }
    getSlideCaption(slideId) {
        return this.el.find('.block-caption[data-caption-id="' + slideId + '"]');
    }
}

export default Testimonials;